import React from "react";
import FieldErrorMsg from "./FieldErrorMsg";
import { ReactComponent as RemoveLinkIcon } from "../../assets/img/common/trash-red-icon.svg";

const ExternalLinkField = ({
  containerClass = "w-40 ",
  inputClass = "h-40",
  itemClass= "h-10",
  id,
  value,
  title,
  placeholder,
  disabled = false,
  formik,
  onBlur = () => {},
  description,
}) => {
  const error = () => {
    if (formik && formik.touched?.[id] && formik.errors?.[id]) return true;
    else return false;
  };
  const handleAddLink = () => {
    formik.setFieldValue(id, [...value, ""]);
  };
  const handleRemoveLink = (index) => {
    let updatedValue = [...value];
    updatedValue.splice(index, 1);
    formik.setFieldValue(id, updatedValue);
  };
  return (
    <div className={`${containerClass} flex flex-col font-roboto relative`}>
      <label htmlFor={id} className=" pl-2">
        <h3 className="font-bold mb-1 text-sm">{title}</h3>
        <p className="text-xs mb-1">{description}</p>
      </label>

      <div
        id={id}
        className={`w-full flex flex-col border ${
          error() ? "border-red-500 border-2" : "border-custom-gray-600 "
        } rounded-[10px] overflow-hidden ${inputClass}`}
      >
        {value?.map((item, index, arr) => (
          <div key={"link_" + index} className="w-full relative">
            <input
              key={id + index}
              type="text"
              placeholder={placeholder}
              onChange={(e) => {
                let cloneVal = [...value];
                cloneVal[index] = e.target.value;
                formik.setFieldValue(id, cloneVal);
              }}
              value={item}
              disabled={disabled}
              id={`${id}.${index}`}
              className={`w-full  extra-link-input text-sm font-[poppins] pl-3 pr-8  custom-select-box  bg-transparent ${itemClass} ${
                error()
                  ? "border-red-500 "
                  : arr?.length > 1 && "border-custom-gray-600 focus:border-2 "
              } ${
                index !== arr?.length - 1 &&
                arr?.length > 1 &&
                `border-b border-custom-gray-600`
              }  `}
            />{" "}
            <button
              type="button"
              onClick={() => handleRemoveLink(index)}
              className="absolute right-1.5 top-0 w-5 h-full rounded-full text-sm flex justify-center items-center "
            >
              <RemoveLinkIcon />
            </button>
          </div>
        ))}
      </div>
      {value?.length < 3 ? (
        <button
          type="button"
          onClick={handleAddLink}
          className="w-fit flex items-center mt-2 rounded-full group relative"
        >
          <span className="w-8 h-8 rounded-full absolute left-0 top-0 group-hover:w-full group-hover:bg-white transition-all duration-300 ease-in"></span>
          <span className="w-8 h-8 rounded-full flex justify-center items-center z-10 bg-white text-[#3C2166] ">
            +
          </span>
          <span className="font-medium ml-2 z-10 pr-3">Add new link</span>
        </button>
      ) : null}
      <FieldErrorMsg formik={formik} id={id} />
    </div>
  );
};

export default ExternalLinkField;
